// Pure state logic for the emotional-dial block, extracted for unit testing. The Backbone model
// used to broker videoTime/playing/timeVals between the video and the chart; the block reducer
// now owns them. viewMode/lineMode stay controlled by props (persisted report-params).

export const initState = ({ videoTime } = {}) => ({ videoTime: videoTime || 0, playing: false, timeVals: [] })

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_VIDEO_TIME':
      return state.videoTime === action.value ? state : { ...state, videoTime: action.value }
    case 'SET_PLAYING':
      return state.playing === action.value ? state : { ...state, playing: action.value }
    case 'SET_TIME_VALS':
      return { ...state, timeVals: action.value }
    default:
      return state
  }
}

// Snap a scrubbed/hovered time to the nearest sample time (ported from the coffee video view's
// timeupdate handler). Empty timeVals => passthrough.
export const snapToTimeVals = (time, timeVals) => {
  if (!timeVals?.length) return time
  return timeVals.reduce((prev, curr) => (Math.abs(curr - time) < Math.abs(prev - time) ? curr : prev))
}
